import AppRegion from '@/types/app-region';
import ComparisonItem from '@/types/comparison-item';
import User from '@/types/user';
import { COMPARISON_ITEM_TYPES } from './constants';
import { validateUserAppRegion } from './users';

/**
 * Filters valid comparison items tax analysis
 * @param {ComparisonItem[]} items the items to filter
 */
export const filterTaxAnalysisItems = (items: ComparisonItem[]) => items.filter(item => item.type !== COMPARISON_ITEM_TYPES.PORTFOLIO);

/**
 * Regions that support tax lot tracking.
 * Add additional regions here as lot tracking is enabled for them.
 */
const LOT_REGIONS: AppRegion[] = [AppRegion.US];

/**
 * Checks if a user is in a region that supports tax lot tracking.
 * @param user user object
 * @returns true if user's region supports lot tracking
 */
export const isUserInLotRegion = (user: User | null | undefined): boolean => {
  return LOT_REGIONS.some(region => validateUserAppRegion(user, region));
};

/**
 * Regions that require purchase date for tax analysis.
 * Add additional regions here as needed.
 */
const REQUIRES_PURCHASE_DATE_REGIONS: AppRegion[] = [AppRegion.US];

export const requiresPurchaseDateForTax = (user: User | null | undefined): boolean => {
  return REQUIRES_PURCHASE_DATE_REGIONS.some(region => validateUserAppRegion(user, region));
};
